import { CreateProjectPortfolioError, ProjectPortfolio } from "@planzone/dto";

function validateProjectPortfolio({
  name,
}: ProjectPortfolio): CreateProjectPortfolioError {
  return {
    portfolioNameIsEmpty: name.length === 0,
    portfolioNameIsNotUnique: false,
  };
}

export { validateProjectPortfolio };
